import {
  BaseTextFieldProps,
  Stack,
  TextField,
} from "@mui/material";
import HelpButton from "../../Buttons/HelpButton/HelpButton";

export interface HelperInputProps extends BaseTextFieldProps {
  helpButtonText?: string;
  fieldSX?: BaseTextFieldProps["sx"];
  direction?: "row" | "row-reverse";
}

const HelpInput = (props: HelperInputProps) => {
  const {
    id,
    label,
    direction = "row",
    type,
    variant,
    children,
    helpButtonText,
    sx = { flexBasis: '100%' },
    fieldSX,
    ...others
  } = props;
  return (
    <Stack
      direction={direction}
      justifyContent="center"
      alignItems="center"
      sx={sx}
    >
      <TextField
        id={id}
        label={label}
        type={type}
        variant={variant}
        fullWidth
        sx={fieldSX}
        {...others}
      >
        {children}
      </TextField>
      {helpButtonText && (
        <HelpButton
          id={id ? id + "-helpButton" : null}
          text={helpButtonText}
          variant={variant}
          sx={{ ml: 1 }}
        />
      )}
    </Stack>
  );
};

export default HelpInput;
